/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".code-output-content{display:table;width:calc(100% - 10px);height:calc(100% - 10px);padding:5px;word-break:break-all}"];
export { styles as styles };
